// Header.jsx
import { Col, Row, Tooltip } from 'antd';
import React, { useEffect } from 'react';
import './header.css';
import PageMenu from '../menu/PageMenu.jsx';
import Logo from '../logo/logo.jsx';
import { useTheme } from '../context/ThemeContext.jsx';

const Header = () => {
    const { theme, setTheme } = useTheme();

    const handleRadioChange = (event) => {
        const isChecked = event.target.checked;
        const newTheme = isChecked ? 'Dark' : 'Light';
        setTheme(newTheme);
        document.documentElement.classList.toggle('dark-theme', isChecked);
    };

    useEffect(() => {
        // Initialize theme class on component mount
        document.documentElement.classList.toggle('dark-theme', theme === 'Dark');
    }, [theme]);

    return (
        <>
            <div className="header_block">
                <div className="max-w-custom mx-auto p-4 pb-0 pt-0">
                    <Row gutter={[16, 16]} className="header_row">
                        <Col xs={12} sm={10} md={8} lg={6} xl={6}>
                            <div className="header_logo_box">
                                <Logo
                                    isDarkBackground={theme === 'Dark'}
                                    isAnimated={true}
                                />
                            </div>
                        </Col>
                        <Col
                            xs={4}
                            sm={4}
                            md={8}
                            lg={12}
                            xl={12}
                            className="header_left">
                            <PageMenu />
                        </Col>
                        <Col
                            xs={8}
                            sm={10}
                            md={8}
                            lg={6}
                            xl={6}
                            className="flex justify-end header_right">
                            {/*<UserAction />*/}
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="theme_box">
                <Tooltip
                    title={
                        document.getElementById('theme')?.checked
                            ? 'Dark'
                            : 'Light'
                    }
                    placement="bottom">
                    <label htmlFor="theme" className="theme">
                        <span className="theme__toggle-wrap">
                            <input
                                id="theme"
                                className="theme__toggle"
                                type="checkbox"
                                role="switch"
                                name="theme"
                                value="dark"
                                checked={theme === 'Dark'}
                                onChange={handleRadioChange}
                            />
                            <span className="theme__fill"></span>
                            <span className="theme__icon">
                                <span className="theme__icon-part"></span>
                                <span className="theme__icon-part"></span>
                                <span className="theme__icon-part"></span>
                                <span className="theme__icon-part"></span>
                                <span className="theme__icon-part"></span>
                                <span className="theme__icon-part"></span>
                                <span className="theme__icon-part"></span>
                                <span className="theme__icon-part"></span>
                                <span className="theme__icon-part"></span>
                            </span>
                        </span>
                    </label>
                </Tooltip>
            </div>
        </>
    );
};

export default Header;